// AUTO-GENERATED by scripts/generate-cn-theme.mjs from src/styles/theme.css — do not edit by hand.
// Regenerated automatically by `pnpm dev`, `pnpm build`, and `pnpm typecheck` (via pre-hooks), or
// manually via `pnpm --filter @commercial-website/ui generate:cn-theme`.
export const cnThemeExtend = {
    text: ['dep-xxs', 'dep-xs', 'dep-sm', 'dep-md', 'dep-lg', 'dep-xl', 'dep-xxl'],
    radius: ['dep-2', 'dep-4', 'dep-8', 'dep-12', 'dep-20', 'dep-full'],
    shadow: ['dep-elevate-quiet', 'dep-raise-quiet'],
    leading: ['dep-xxs', 'dep-xs', 'dep-sm', 'dep-md', 'dep-lg', 'dep-xl', 'dep-xxl'],
};
